import { Container } from 'inversify'
import { ErrorPlatformEvent, interpret } from 'xstate'
import { rootContainer } from '~/container'
import sentryCapture from '~/utility/sentryCapture'
import { returnPopularLocationsMachine } from './machine'
import { PopularLocationsRepositoryFetch } from './PopularLocationsRepositoryFetch'
import { PopularLocationsRepository } from './repositories'

const popularLocationsContainer = new Container()
popularLocationsContainer.parent = rootContainer

popularLocationsContainer
  .bind(PopularLocationsRepository)
  .to(PopularLocationsRepositoryFetch)

export function getPopularLocationsMachine(langCode: string, limit: number) {
  return interpret(
    returnPopularLocationsMachine().withConfig({
      services: {
        fetch: async () => {
          return await popularLocationsContainer
            .get(PopularLocationsRepository)
            .fetch(langCode, limit)
        },
      },
      actions: {
        logError: (_, _event: any) => {
          const event: ErrorPlatformEvent = _event
          event.data.name = `popularLocationsMachine ${event.type} error`
          sentryCapture(event.data, rootContainer)
        },
      },
    }),
  )
}
